import React from 'react'
import deleteIcon from '../assets/images/icons/delete.png'

const DeleteButton = ({ onClick }) => {
  return (
    <button
      className="vehicle-delete-button"
      style={{
        border: '1.5px solid #a33',
        background: '#f5f5f5',
        borderRadius: 6,
        height: 28,
        padding: '3.5px 9px 6px 10px',
        cursor: 'pointer',
        fontWeight: 700,
        boxShadow: '0 1px 8px rgba(0,0,0,0.30)',
        transition: 'transform 0.05s ease, box-shadow 0.1s ease',
        outline: 'none'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = '#f3bcbc'
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = '#f5f5f5'
        e.currentTarget.style.transform = 'scale(1)'
        e.currentTarget.style.boxShadow = '0 1px 8px rgba(0,0,0,0.30)'
      }}
      onMouseDown={(e) => {
        e.currentTarget.style.transform = 'scale(0.96)'
        e.currentTarget.style.boxShadow = '0 0px 4px rgba(0,0,0,0.25)'
      }}
      onMouseUp={(e) => {
        e.currentTarget.style.transform = 'scale(1)'
        e.currentTarget.style.boxShadow = '0 1px 8px rgba(0,0,0,0.30)'
        e.currentTarget.blur()
      }}
      onClick={onClick}
    >
      <img
        src={deleteIcon}
        alt="delete"
        style={{
          width: 19,
          height: 19,
          display: 'block'
        }}
      />
    </button>
  )
}

export default DeleteButton